import React from "react";
import MarkTracing from "components/Tvendo/Mobile/Tracing/Mark/List.js";
import { LayerProvider } from "contexts/layerContext";

export default function () {
  return (
    <LayerProvider>
      <MarkTracing />
    </LayerProvider>
  );
}
